export const contentInitialState = {
  content: {
    store: {},
    isDataLoaded: false,
    isLoading: false,
    isFetchError: null,
  },

  allCountries: {
    isDataLoaded: false,
    isFetchError: null,
    isLoading: false,
    data: {},
  },

  countryInfo: {
    isDataLoaded: false,
    data: {},
  },

  menuProxy: {
    isLoading: false,
    isDataLoaded: false,
    isFetchError: null,
    data: [],
  },

  html: {
    isLoading: false,
    isDataLoaded: false,
    isFetchError: null,
    data: "",
  },
};
